export enum UscType {
  NonFinancial = 1,
  Financial = 2,
}
